@if (banner) {
  <div class="alert-banner" [ngClass]="banner.type">
    <!-- Left block content -->
    <div class="banner-content left">
      <!-- Icon -->
      @if (banner.iconSrc) {
        <span class="alert-icon">
          <img width="19.5px" height="19.5px" [src]="banner.iconSrc" />
        </span>
      }

      <!-- Title -->
      @if (banner.title) {
        <strong class="alert-text">{{ banner.title }}</strong>
      }

      <!-- Message with optional translation -->
      <span class="alert-text">
        {{ banner.data?.disconnectedModelName }}
        @if (banner.translationKey) {
          {{ (banner.translationKey | translate) || "Alert Message " }}
        }
      </span>

      <!-- Message -->
      @if (banner.message) {
        <span>{{ banner.message }}</span>
      }

      <!-- HTML Content -->
      @if (banner.htmlContent) {
        <div [innerHTML]="banner.htmlContent">{{banner.htmlContent}}</div>
      }
    </div>

    <!-- Right block content-->
    <div class="alert-text banner-content right">
      @if (banner.isIndefinite) {
        {{ 'lang.indefinite' | translate }}
      }

      @if (!banner.isIndefinite && banner.countdownText) {
        {{ banner.countdownText }}
      }
    </div>
  </div>
}